import * as Sentry from '@sentry/vue';
import SentryFullStory from '@sentry/fullstory';

const SENTRY = {
    VUE_APP_SENTRY_KEY: 'https://c777ad1c169444f0a2ae9a5d401015fa@o153719.ingest.sentry.io/5516084',
    VUE_APP_SENTRY_ORG: 'infusionsoft-core',
};

export default {
    init(app,
        key = SENTRY.VUE_APP_SENTRY_KEY,
        org = SENTRY.VUE_APP_SENTRY_ORG) {
        try {
            Sentry.init({
                app,
                dsn: key,
                environment: window.environment.toLowerCase(),
                tracesSampleRate: 1.0,
                ignoreErrors: [
                    /^Request failed with status code \d{3}$/,
                    /Object Not Found Matching Id:\d+/,
                    'Network error: Failed to fetch',
                    'ChunkLoadError',
                    'Redirected when going from', // https://github.com/vuejs/vue-router/blob/v3.3.4/src/history/errors.js#L13
                    'Avoided redundant navigation', // https://github.com/vuejs/vue-router/blob/v3.3.4/src/history/errors.js#L24
                    'Navigation cancelled', // https://github.com/vuejs/vue-router/blob/v3.3.4/src/history/errors.js#L33
                    'Navigation aborted', // https://github.com/vuejs/vue-router/blob/v3.3.4/src/history/errors.js#L44
                ],
                integrations: [
                    new SentryFullStory(org, {}),
                ],
                denyUrls: [
                    // Ignore Amplitude and FullStory errors
                    /api\.amplitude\.com/i,
                    /rs\.fullstory\.com/i,
                ],
            });
        } catch (error) {
            // eslint-disable-next-line no-console
            console.error('Error initializing Sentry:', error);
        }
    },

    captureException(error, options = {}) {
        try {
            if (window.environment === 'Production') {
                Sentry.withScope((scope) => {
                    const { message, data } = options;

                    if (message) {
                        scope.setTransactionName(message);
                    }

                    if (data) {
                        Object.keys(data).forEach((key) => {
                            scope.setExtra(key, data[key]);
                        });
                    }

                    Sentry.captureException(error);
                });
            }
        } catch (e) {
            // swallow sentry failures
        }
    },
};
